import { z } from 'zod';
// ============================================================
// Section Types
// ============================================================
export const SECTION_TYPES = [
    'cover', 'greeting', 'parents', 'ceremony', 'venue', 'gallery',
    'contacts', 'accounts', 'rsvp', 'guestbook',
    'timeline', 'schedule', 'notices', 'footer',
];
const CustomSectionTypeSchema = z.string().regex(/^custom-[\w-]+$/, '커스텀 섹션 타입은 custom-{slug} 형식이어야 합니다');
export const SectionTypeSchema = z.enum(SECTION_TYPES).or(CustomSectionTypeSchema);
/** 커스텀 섹션 타입인지 확인 */
export function isCustomSectionType(type) {
    return type.startsWith('custom-');
}
// ============================================================
// Section Design CRUD Schemas
// ============================================================
export const CreateSectionDesignSchema = z.object({
    sectionType: SectionTypeSchema,
    name: z.string().min(1, '이름을 입력해주세요'),
    slug: z.string().min(1).max(64),
    htmlContent: z.string().min(1, 'HTML 내용을 입력해주세요'),
    cssContent: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    thumbnail: z.string().max(500).nullable().optional(),
    tags: z.array(z.string()).default([]),
    isActive: z.boolean().default(true),
    sortOrder: z.number().int().default(0),
});
export const UpdateSectionDesignSchema = CreateSectionDesignSchema.partial();
// ============================================================
// Template Composition Schema
// ============================================================
export const TemplateCompositionSchema = z.object({
    sections: z.array(z.object({
        sectionType: SectionTypeSchema,
        sectionDesignId: z.string(),
    })),
});
// ============================================================
// Composition Mode
// ============================================================
export const CompositionModeSchema = z.enum(['monolithic', 'composed']);
//# sourceMappingURL=section-design.js.map